// =============================================================================
//  Copyright : 2025 semantics GmbH
//  Date      : $Date: 2025-09-30 17:11:11 +0200 (Tue, 30 Sep 2025) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 156745 $
//  Purpose   : access restriction package
// =============================================================================

export const dashpanels = true
